import { TextInput, Button, Box } from "@mantine/core";
import { IconSearch, IconX } from "@tabler/icons-react";
import { ChangeEvent, useEffect, useRef } from "react";
import { useDebouncedCallback } from "use-debounce";
import { isSearchTooShort, MIN_SEARCH_LENGTH } from "../utils/orderSearch";

interface SearchBarProps {
  searchText?: string;
  onSearchChange: (value: string) => void;
}

const SearchBar = ({ searchText = "", onSearchChange }: SearchBarProps) => {
  const ref = useRef<HTMLInputElement>(null);
  const debouncedOnChange = useDebouncedCallback(
    (e: ChangeEvent<HTMLInputElement>) => onSearchChange(e.target.value),
    250
  );

  useEffect(() => {
    // Reset searchBar value if the searchText has been reset
    if (!searchText || (!ref.current?.value && searchText)) {
      if (ref.current) ref.current.value = searchText;
    }
  }, [searchText]);

  return (
    <Box>
      <TextInput
        ref={ref}
        label="Search"
        flex="5"
        placeholder="Search by order reference, patient name, or doctor name..."
        description={
          isSearchTooShort(searchText)
            ? `Type at least ${MIN_SEARCH_LENGTH} characters to search`
            : undefined
        }
        onChange={debouncedOnChange}
        leftSection={<IconSearch size={16} />}
        rightSection={
          searchText ? (
            <Button
              variant="subtle"
              size="xs"
              onClick={() => {
                onSearchChange("");
              }}
              leftSection={<IconX size={12} />}
            >
              Clear
            </Button>
          ) : null
        }
      />
    </Box>
  );
};

export default SearchBar;
